export function canApplyDraft(result, now = Date.now()) {
  const draft = result?.draft;
  return Boolean(draft?.id && draft.status === "ready" && Date.parse(draft.expires_at) > now);
}
